import { Controller } from "@hotwired/stimulus"

// THE DUE > PEOPLE BULK "SCHEDULE TRAINING" BUTTON (TASK-292.4, decision-105).
// Sits beside `form-picker` on the same row checkboxes (each carries both
// controllers' `change` actions) and layers one rule on top of its
// enable/disable: one session teaches one course, so every ticked row must
// share a course. Mixed courses disable the button and show the hint.
// Select-all / Clear tick boxes without a native change event, so the wrapper
// also listens for `form-picker:updated`.
//
// The slideover src is built here from the ticked rows; the server prefills
// the course and the people from it (Competency::SessionsController#new).
export default class extends Controller {
  static targets = ["checkbox", "button", "hint"]
  static values = { newPath: String, returnTo: String }

  recompute() {
    if (!this.hasButtonTarget) return

    const checked = this.checkboxTargets.filter((checkbox) => checkbox.checked && !checkbox.disabled)
    const button = this.buttonTarget
    if (this.hasHintTarget) this.hintTarget.hidden = true

    if (checked.length === 0) {
      button.disabled = true
      button.removeAttribute("title")
      button.textContent = "Schedule Training"
      return
    }

    const courseIds = new Set(checked.map((checkbox) => checkbox.dataset.courseId))
    if (courseIds.size > 1) {
      button.disabled = true
      button.title = "Pick rows for one course at a time"
      if (this.hasHintTarget) this.hintTarget.hidden = false
      return
    }

    button.disabled = false
    button.removeAttribute("title")
    button.textContent = `Schedule Training for ${checked.length}`

    const params = new URLSearchParams()
    params.set("training_course_id", checked[0].dataset.courseId)
    checked.forEach((checkbox) => params.append("member_ids[]", checkbox.value))
    if (this.returnToValue) params.set("return_to", this.returnToValue)
    button.setAttribute("data-slideover-turbo-frame-src-value", `${this.newPathValue}?${params.toString()}`)
  }
}
